import React, { useEffect } from 'react';
import { Row, Col, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import XLSX from 'xlsx';
import ReportTable from './ReportTable'
import { usePersistedStore } from '../../store/persisted-store';
import { useReportsStore } from '../../store/slices/createReportsSlice';

export default function AgentsBalance() {
    const reports = useReportsStore()
    const navigate = useNavigate();
    const { business } = usePersistedStore();

    const data = reports.agentsBalance.data;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;

    useEffect(() => {
        if (!token)
            navigate('/dashboard');
        reports.getAgentsBalance();
    }, [navigate, token]);

    function downloadxlsx() {
        if (!data) return
        let xlsxData = data.map(d => [
            d.Username,
            d.FullName,
            d.SumPaid,
            d.SumCommission,
            d.RemainAmount,
            d.ProvinceName,
            d.CityName
        ])
        xlsxData.unshift(['نام کاربری', 'نام و نام خانوادگی', 'جمع پرداختی', 'جمع کارمزد', 'مانده', 'استان', 'شهر'])
        const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
        const new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
        XLSX.writeFile(new_workbook, "bimeh[dot]com.xlsx")
    }

    return (
        <Card>
            <Row gutter={[16]} justify="end" align="middle">
                <Col>
                    <button type="primary" className="btn btn-success waves-effect waves-light" htmltype="submit"
                        onClick={downloadxlsx}>
                        <i className="far fa-file-excel font-size-14 align-middle mr-2"></i> دریافت اکسل
                    </button>
                </Col>
            </Row>
            <Row gutter={[16, 16]} justify="start" align="middle">
                <Col span={24}>
                    <ReportTable />
                </Col>
            </Row>
        </Card>
    )
}
